import DebitsByTutor from './DebitsByTutor';

export default DebitsByTutor;
